<div
  class="vtmn-rating"
  [ngClass]="ratingSizeClass"
  [class.vtmn-rating_variant--brand]="emphasis"
>
  <ng-container *ngIf="compact">
    <span [ngClass]="compactIconClass" role="presentation"></span>
  </ng-container>

  <ng-container *ngIf="!compact">
    <span
      *ngFor="let iconClass of iconClasses"
      [class]="iconClass"
      role="presentation"
    ></span>
  </ng-container>

  <span *ngIf="showValue" class="vtmn-rating_comment--primary">
    <span class="vtmx-sr-only"></span>
    {{ value?.toFixed(1) }}
  </span>

  <span *ngIf="comments" class="vtmn-rating_comment--secondary">
    <span class="vtmx-sr-only"></span>
    {{ comments }}
  </span>
</div>
